﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251227
    This script contains functions used for javascript arrays
*/

const getMinValue = ({ arr, fldNm, initValue }) => {
    if (!arr || arr.length === 0) {
        throw new Error('getMinValue requires populated array named in arr parameter');
    }
    if (!fldNm) {
        throw new Error('getMinValue requires fldNm property in params');
    }
    return arr.reduce(
        (min, obj) => (obj[fldNm] < min ? obj[fldNm] : min),
        initValue !== undefined ? initValue : arr[0][fldNm]
    );
};

const getPropNmAndKey = id => {
    /*
    getPropNmAndKey is a function that takes an Id and returns the Property Name and Id 
    in a javascript object.  When passed Name_9 it would return the following object
        
        { propNm: 'Name', key: 9 }
    */
    const [propNm, keyStr] = id.split('_');
    const key = isNaN(keyStr) ? keyStr : Number(keyStr); //key = parseInt(key, 10);
    return { propNm, key };
}

const getTempKey = (params = {}) => {
    // Returns the first unique negative to be used as a key.
    // All rows sent to the api with a negative key are inserted
    // into the database, while all rows with positive keys update
    // an existing row in the database.

    const {
        arr,
        fldNm
    } = params;

    if (!fldNm || typeof fldNm !== "string" || !Array.isArray(arr)) {
        throw new Error("arr and fldNm are required parameters for ctssArrayUtils.getTempKey"); 
    }

    try {
        if (arr.length === 0) return -1;
        return getMinValue({ arr, fldNm, initValue: 0 }) - 1;
    } catch (error) {
        alert(error.message);
    }
};

export { getMinValue, getPropNmAndKey, getTempKey };
